import React, { useRef, useState } from 'react';
import {
  StyledAccordion,
  StyledAccordionSummary,
  StyledAccordionDetails,
  StyledComment,
} from 'components/molecules/ThreadAccordion/styles';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { ICaseOtherComments } from 'models/cases';
import { useTranslations } from 'hooks/useTranslations';
import { useScrollToLatestItem } from 'hooks/useScrollToLatestItem';
import { formatDate } from 'utils/date';
import { useGlobalProperty } from 'models/globalPropertyContext';
import { getHtmlText } from 'components/organisms/HtmlSlate';
import { AccordionContainer } from 'components/molecules/CustomizedAccordions/styles';

export interface ICaseThreadsAccordions {
  items: ICaseOtherComments[];
  defaultExpandedIndex?: number | false;
}

export const CaseCommentsAccordions = ({
  items,
  defaultExpandedIndex = false,
}: ICaseThreadsAccordions) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { t } = useTranslations();
  const [expanded, setExpanded] = useState<number | false>(defaultExpandedIndex);
  const { longDateFormat } = useGlobalProperty();

  useScrollToLatestItem(items, containerRef, setExpanded);

  const handleChange =
    (index: number) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? index : false);
    };

  if (!items.length) {
    return null;
  }

  return (
    <AccordionContainer ref={containerRef}>
      {items.map((item, index) => (
        <StyledAccordion
          key={index}
          expanded={expanded === index}
          onChange={handleChange(index)}
        >
          <StyledAccordionSummary
            expandIcon={
              <>
                <span className="icon-plus">
                  <Icon type={EIconTypes.plus} fontSize={11} color={colors.black} />
                </span>

                <span className="icon-minus">
                  <Icon type={EIconTypes.minus} fontSize={11} color={colors.black} />
                </span>
              </>
            }
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            style={expanded === index ? { paddingBottom: 0 } : {}}
          >
            <Grid>
              <Typography variant="subtitle2" sx={{ color: colors.primary900 }}>
                {`${t('general.added.label')} ${formatDate(item.createdDate, longDateFormat)} ${t('general.by.label')} ${item.authorName} (${item.authorDisplayUniqueId})`}
              </Typography>
            </Grid>
          </StyledAccordionSummary>
          <StyledAccordionDetails style={{ paddingLeft: '36px' }}>
            <Grid size={{ xs: 12 }}>
              <Typography variant="body2">{item.comment}</Typography>
            </Grid>
          </StyledAccordionDetails>
        </StyledAccordion>
      ))}
    </AccordionContainer>
  );
};
